// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ling-star-rating {\n  -webkit-transition: color 0.3s ease-in-out, opacity 0.3s ease-in-out;\n  transition: color 0.3s ease-in-out, opacity 0.3s ease-in-out;\n}\n.ling-star-rating.empty {\n  opacity: 0.3;\n}\n.ling-star-rating:not(.empty):hover {\n  color: var(--lingusta-green);\n}", ""]);
// Exports
module.exports = exports;
